import { useState, useEffect } from 'react';

const MaintenanceBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const now = new Date();
    const utcHour = now.getUTCHours();
    const estHour = (utcHour - 5 + 24) % 24; // Convert UTC to EST

    // if (true) { // For testing: always show
    if (estHour >= 23 || estHour < 6) {
      setIsVisible(true);
    }

    // Dismiss banner on any click
    const handleClick = () => setIsVisible(false);
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        left: '0',
        right: '0',
        backgroundColor: '#f44336',
        color: 'white',
        padding: '12px 24px',
        zIndex: 1000,
        fontSize: '16px',
        textAlign: 'center',
        width: '95%',
        margin: '0 auto',
        borderRadius: '20px',
        pointerEvents: 'auto',
      }}
    >
      Site maintenance in progress from <br />
      11:00 PM to 6:00 AM EST.
      <br /><br />
      If an error occurs, please wait 3 minutes and try again.
    </div>
  );
};

export default MaintenanceBanner;
